import React, { useState } from 'react';
import { Search, X, Clock, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Header } from '../components/ui/Header';
export function SearchScreen() {
  const {
    goBack
  } = useNavigation();
  const [query, setQuery] = useState('');
  const recent = ['Wireless earbuds', 'Sneakers', 'Smart watch'];
  const trending = ['iPhone 15', 'Gaming Mouse', 'Backpack', 'Lipstick'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="min-h-screen bg-white" data-id="element-1319">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-100" data-id="element-1320">
        <div className="flex-1 relative" data-id="element-1321">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1322" />
          <input autoFocus type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search products..." className="w-full bg-gray-100 rounded-xl py-2.5 pl-10 pr-10 text-sm focus:outline-none focus:ring-1 focus:ring-primary" data-id="element-1323" />
          {query && <button onClick={() => setQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1324">
              <X className="w-4 h-4" data-id="element-1325" />
            </button>}
        </div>
        <button onClick={goBack} className="text-sm font-medium text-gray-600" data-id="element-1326">
          Cancel
        </button>
      </div>

      {!query && <div className="p-4" data-id="element-1327">
          <div className="mb-6" data-id="element-1328">
            <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-1329">
              <Clock className="w-4 h-4" data-id="element-1330" /> Recent Searches
            </h3>
            <div className="flex flex-wrap gap-2" data-id="element-1331">
              {recent.map(item => <button key={item} className="px-4 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-sm text-gray-600" data-id="element-1332">
                  {item}
                </button>)}
            </div>
          </div>

          <div data-id="element-1333">
            <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-1334">
              <TrendingUp className="w-4 h-4 text-primary" data-id="element-1335" /> Trending Now
            </h3>
            <div className="flex flex-wrap gap-2" data-id="element-1336">
              {trending.map(item => <button key={item} className="px-4 py-1.5 bg-accent-50 text-accent-700 border border-accent-200 rounded-full text-sm font-medium" data-id="element-1337">
                  {item}
                </button>)}
            </div>
          </div>
        </div>}
    </motion.div>;
}